<template>
  <svg
    width="142"
    height="200"
    viewBox="0 0 142 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M98.5684 47.0713L130 65.0001L125.431 73.0094L93.9998 55.0805L98.5684 47.0713Z"
      fill="var(--accentColor)"
    />
    <path
      d="M60 121.244V165.621"
      stroke="var(--contrastColor)"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M93.2822 121.244V165.621"
      stroke="var(--contrastColor)"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <rect
      x="10.6704"
      y="88.3232"
      width="125.476"
      height="11"
      rx="3"
      transform="rotate(-35.8466 10.6704 88.3232)"
      stroke="var(--contrastColor)"
      stroke-width="2"
    />
    <path
      d="M83.9565 35.2812L78.6209 27.9124C77.2058 25.958 74.902 24.7692 72.2162 24.6075C69.5304 24.4457 66.6826 25.3243 64.2994 27.0499L37.3418 46.5692C34.9586 48.2949 33.2352 50.7262 32.5506 53.3283C31.8661 55.9304 32.2765 58.4902 33.6915 60.4445L39.0271 67.8134"
      stroke="var(--contrastColor)"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M124.213 57.5386L120.857 63.3519"
      stroke="var(--contrastColor)"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M106.773 47.4692L103.417 53.2826"
      stroke="var(--contrastColor)"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M92.7939 54.9009L124.767 73.3607"
      stroke="var(--contrastColor)"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M98.0454 67.6206L103.132 70.5574L98.1277 72.5126C98.6065 72.7879 99.01 73.1772 99.3023 73.6459C99.5946 74.1146 99.7668 74.6481 99.8034 75.1993C99.8401 75.7504 99.7402 76.3021 99.5125 76.8054C99.2849 77.3086 98.9365 77.748 98.4984 78.0843C98.0603 78.4207 97.5459 78.6437 97.0009 78.7336C96.4559 78.8236 95.8971 78.7776 95.3741 78.5998C94.8512 78.422 94.3802 78.1178 94.0029 77.7144C93.6257 77.3109 93.3538 76.8206 93.2115 76.2868"
      stroke="var(--contrastColor)"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M97.8553 48.1325C98.0426 47.8081 98.4574 47.697 98.7817 47.8843L127.848 64.6659C128.173 64.8532 128.284 65.2679 128.097 65.5923L114.609 88.9531H116.919L129.829 66.5923C130.568 65.3113 130.129 63.6734 128.848 62.9338L99.7817 46.1522C98.5008 45.4127 96.8628 45.8516 96.1233 47.1325L79.3417 76.1991C78.6021 77.4801 79.041 79.118 80.3219 79.8575L96.076 88.9531H100.076L81.3219 78.1255C80.9976 77.9382 80.8865 77.5235 81.0737 77.1991L97.8553 48.1325Z"
      fill="var(--contrastColor)"
    />
    <path
      d="M106.234 75.2552L110.399 74.7534L104.945 84.2"
      stroke="var(--contrastColor)"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M28 90H126V190C126 194.971 121.971 199 117 199H37C32.0294 199 28 194.971 28 190V90Z"
      stroke="var(--contrastColor)"
      stroke-width="2"
    />
  </svg>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {},
  created() {},
  components: {},
  props: [],
};
</script>
<style scoped></style>
